import React, { PureComponent } from 'react';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { track } from '@client/helpers';
import ResetPasswordContent from './resetPasswordContent/ResetPasswordContent';

export class ResetPasswordSuccess extends PureComponent {
    render() {
        return (
            <TranslationsScope path="resetPasswordSuccess">
                <ResetPasswordContent closeOverlay={this.props.closeOverlay} />
            </TranslationsScope>
        );
    }

    componentDidMount() {
        track('onboarding.success_action', {
            success_description: 'resetPasswordSuccess',
        });
    }
}

export default ResetPasswordSuccess;
